import styled from 'styled-components'
import { COLORS } from 'utils'

export const BorderLine = styled.div`
  background-color: ${COLORS.primary};
  border-radius: 4px 4px 0 0;
  height: 8px;
`

interface IBorderLineProps {
  colorLine?: string
  height?: string
}
export const BorderLineSuccess = styled.div<IBorderLineProps>`
  background-color: ${({ colorLine }) => colorLine || COLORS.primary};
  border-radius: 4px 4px 0 0;
  height: ${({ height }) => height || '8px'};
`

export const DecorativeLine = styled.div<IBorderLineProps>`
  background-color: ${({ colorLine }) => colorLine || COLORS.primary};
  height: ${({ height }) => height || '8px'};
`
